<div class="container-fluid">
    <div>
        <app-offices-header (searchByName)="searchOfficeByName($event)" [tableSettings]="tableSetting.columns"></app-offices-header>
    </div>
    <div class="mt-1">
  <table class="table">
      <thead>
          <tr>
              <td class="w-20" *ngFor="let column of tableSetting.columns;let i = index">
                    <div *ngIf="column.isSortable">

                        <span class="columheader" style="cursor:pointer">{{column.title}}</span>                   
                        <span class="icon-ic_filtered column-filter-icon cursor-pointer"  (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>
                        
                    </div>
                    <div  *ngIf="!column.isSortable">
                        <span class="columheader">{{column.title}}</span>
                    </div>
                    <div class="resource-dropdown" *ngIf="column.displaysort">
                        <app-offices-filter [cityArray] = "cityArray" 
                                            [statusArray] = "statusArray"
                                            [column]="column"
                                            [tableSettings]="tableSetting"
                                            (gridFiltersApplied)="checkFilterApplied($event)">
                        </app-offices-filter>   
                    </div>
              </td>
          </tr>
      </thead>
      <tbody class="results-list-panel">          
                <div class="no-search-results" *ngIf="((usersList!=null)&&(usersList.length==0))">
                    <span class="icon-ic_Search_NEG_circle"></span>
                    <label>No results found</label>
                </div>
                <tr *ngFor="let d of usersList | paginate: { itemsPerPage: 10, currentPage: p, totalItems: totalCount};let i = index">                 
                    <td>
                        <span class="showellipsis" tooltip={{d.cityName}}>{{d.cityName}}</span>
                    </td>
                    <td class="text-truncate">
                        <span class="showellipsis" tooltip={{d.officeName}}>{{d.officeName}}</span>
                    </td>
                    <td >  
                        <span class="showellipsis1">{{d.officeAddress}}</span>
                    </td>
                    <td> 
                        <span class="circle" [ngClass]="{'bg-red': !d.isActive,'bg-green': d.isActive}"></span>
                        <span class="showellipsis">{{d.isActive ? 'Active' : 'Inactive'}}</span>                  
                    </td>
                    <!-- <td>
                        <span class="showellipsis" >{{d.postWorkingHour}}</span>                  
                    </td> -->
                    <td>
                        <span class="showellipsis" tooltip="{{d.dateAdded | date:'d/MMM/y, h:mm a'}}">{{d.dateAdded | date:'d/MMM/y, h:mm a'}}</span>                  
                    </td>
                    <td>
                        <span class="showellipsis" tooltip={{d.addedBy}}>{{d.addedBy}}</span>                  
                    </td>
                    <td class="d-flex justify-content-end">
                        <i class="icon-ic_edit px-2" (click)="showEditData(d)" style="cursor: pointer;" ></i> 
                        <i class="icon-ic_delete px-2" (click)="deleteOffice(d.officeID,d)" style="cursor: pointer;"></i>                                   
                    </td>
                </tr>
          </tbody>
      </table>
    </div>
    <div class="paginationwithcount" *ngIf="((usersList!=null)&&(usersList.length>0))" (click)="hideDropdowns()">
        <span class="mb-4 mx-4">Page</span>
        <pagination 
                    [(ngModel)]="filterData.page"
                    [boundaryLinks]="true" 
                    (pageChanged)="changeCurrentPage($event);p = $event"
                    [(totalItems)] = "totalCount"
                    [maxSize]="5"
                    firstText="&shy;"
                    lastText="&shy;"
                    previousText="&shy;"
                    nextText="&shy;"
                    [rotate]="false"
                    [itemsPerPage] = "itemsperPage"
                    >
        </pagination>  
    </div>
    <div class="totalcount" *ngIf="((usersList!=null)&&(usersList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span></div>
</div>
